module.exports = __webpack_public_path__ + "img/caseimeivivoscan.083ea8dc.png";